<template>
  <v-container
    fluid
    class="pa-0 bigger"
    :class="{ 'personal-container': $vuetify.breakpoint.mdAndUp }"
  >
    <app-stepper v-model="step" :steps="steps" />
  </v-container>
</template>
<script>
/* eslint-disable no-console */
import { PracticeSteps } from "./stepsDefinition";
import Stepper from "./components/Stepper.vue";

export default {
  components: {
    appStepper: Stepper,
  },
  data() {
    return {
      steps: PracticeSteps,
    };
  },
  computed: {
    step: {
      get() {
        return this.$store.getters["lesson/step"];
      },
      set(value) {
        return this.$store.commit("lesson/step", value);
      },
    },
  },
  beforeRouteLeave(to, from, next) {
    this.step = 0;
    next();
  },
};
</script>
<style scoped>
.personal-container {
  padding-left: 87px !important;
  padding-right: 160px !important;
}
.bigger {
  padding-top: 3% !important;
}
</style>
